import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const DrillSelectionPath = ({ filterVals, onSelectLevel }) => {
  const drillSelections = useMemo(() => {
    const filters = filterVals?.filter ?? [];
    return filters
      .filter((item) => !item?.isDefault)
      .map((item) => ({
        field: item?.field,
        value: item?.value,
      }))
      .filter((item) => item.field && item.value !== undefined && item.value !== null && `${item.value}` !== '');
  }, [filterVals]);

  if (!drillSelections.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 0.5,
        mt: 0.5,
        mb: 1,
      }}
    >
      {drillSelections.map((item, index) => {
        const isActiveLevel = index === drillSelections.length - 1;
        const isClickable = !!onSelectLevel && !isActiveLevel;

        return (
          <React.Fragment key={`${item.field}-${item.value}-${index}`}>
            {index > 0 && <NavigateNextIcon sx={{ fontSize: 16, color: 'text.secondary' }} />}
            <Typography
              variant="body2"
              onClick={() => {
                if (isClickable) {
                  onSelectLevel(index, item);
                }
              }}
              sx={{
                color: 'text.secondary',
                cursor: isClickable ? 'pointer' : 'default',
                '&:hover': isClickable ? { textDecoration: 'underline' } : {},
              }}
            >
              {item.value}
            </Typography>
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default DrillSelectionPath;
